import { ArrowUpward, Article, EditOutlined, MoreVert, QueryStats, QueryStatsOutlined, Star, Verified, Visibility, VisibilityOutlined } from '@mui/icons-material'
import { Box, Button, Grid, IconButton, Typography } from '@mui/material'
import { axisClasses, LineChart } from '@mui/x-charts';
import React, { useEffect, useState } from 'react'
import { HiOutlineCube } from "react-icons/hi2";
import { Link } from 'react-router-dom';
import { ApiGetShopDashboard, ApiGetShopProfile } from '../../Core/Apicall';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setVenderDetails } from '../../Redux/Reducers/globalSlice';
import { RootState } from '../../Redux/store';
import { RecentOrder,  ShopDashboard,  TopSellingProduct } from '../../Models/ShopDashboard';
import dayjs from 'dayjs';


function VenderDashboard() {
    // const [profileData, setProfileData] = useState<>()
    const { venderDetails, teamId } = useSelector((state: RootState) => state.global)
    const dispatch = useDispatch()
    const margin = { right: 24 };
    const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
    const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
    const xLabels = [
        'Page A',
        'Page B',
        'Page C',
        'Page D',
        'Page E',
        'Page F',
        'Page G',
    ];
    const [dashboardDetails, setDashboardDetails] = useState<ShopDashboard>()

    // const getShopProfile = async () => {
    //     try {
    //         const data =`?profileId=${teamId}`
    //         const res = await ApiGetShopProfile(data)
    //         if (res.success || res.status) {
    //             dispatch(setVenderDetails(res?.data?.data[0]))
    //         }
    //     } catch (error: any) {
    //         console.log("Error", error)
    //          toast.error(error?.message || "Something went wrong");
    //     }
    // }

    const getDashboard = async () => {
        try {
            const data = `?shopProfileId=${venderDetails?.shopProfileId}`
            const res = await ApiGetShopDashboard(data)
            setDashboardDetails(res?.data)
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    useEffect(() => {
        // if(venderDetails)
        getDashboard()
        // getShopProfile()
    }, [])

    return (
        <Box className='h-100 overflow-auto p-3'>
            <Grid container spacing={1.5} className='w-100 mb-1'>
                <Grid size={{ xs: 12, lg: 3 }} sx={{ minHeight: '138px' }} className='bg-main position-relative border-main border-10 p-3'>
                    <Typography className='text-white fs-14 fw-bold'>Welcome back,</Typography>
                    <Box className='d-flex align-items-center  gap-2 text-white fs-20 fw-bold mb-3'><span>{dashboardDetails?.shopProfile?.displayName}</span> <Verified className='text-yellow' /></Box>
                    <Typography className='text-white fs-12'>Manage youre store and grow your business</Typography>
                    <Box component={'img'} className='position-absolute end-0 top-0' sx={{ opacity: '0.3' }} src={dashboardDetails?.shopProfile?.logo} height={'100%'} />
                </Grid>
                <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-12 text-white'>Total Sales</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold whitespace'>{dashboardDetails?.statistics?.sales?.total}</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> {dashboardDetails?.statistics?.sales?.change}%</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--secondary-light-color)', borderRadius: '50px' }}>
                            <QueryStatsOutlined className='text-yellow fs-28' />
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
                <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-12 text-white'>Total Orders</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2 ">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold'>{dashboardDetails?.statistics?.orders?.total}</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' />{dashboardDetails?.statistics?.orders?.change}%</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2 bg-light-primary' sx={{ background: 'var(--blue-light-color)', borderRadius: '50px' }}>
                            <Article className='fs-32' sx={{ color: 'var(--blue-color)' }} />
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
                <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-12 text-white'>Total Products</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2 ">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold'>{dashboardDetails?.statistics?.products?.total}</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> {dashboardDetails?.statistics?.products?.change}%</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--purple-light-color)', borderRadius: '50px' }}>
                            {HiOutlineCube({ size: 32, color: 'var(--purple-color)' })}
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
                <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-12 text-white'>Total Revenue</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2 ">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold'>${dashboardDetails?.statistics?.revenue?.total}</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> {dashboardDetails?.statistics?.revenue?.change}%</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--third-light-color)', borderRadius: '50px' }}>
                            <Visibility className='fs-28' sx={{ color: 'var(--third-color)' }} />
                        </Box>
                        {/* <Box component={'img'} src=''></Box> */}
                    </Box>
                </Grid>
                {/* <Grid size={{ xs: 6, lg: 'grow' }} sx={{ minHeight: '138px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Typography className='fs-12 text-white'>Store view</Typography>
                    <Box className="d-flex align-items-start justify-content-between mt-2 ">
                        <Box>
                            <Typography className='text-white fs-20 fw-bold'>N/A</Typography>
                            <Typography className='text-success fs-14'><ArrowUpward className='text-sucess' /> N/A</Typography>
                            <Typography className='text-white fs-12'>vs last 7 days</Typography>
                        </Box>
                        <Box className='p-2' sx={{ background: 'var(--third-light-color)', borderRadius: '50px' }}>
                            <Visibility className='fs-28' sx={{ color: 'var(--third-color)' }} />
                        </Box>
                    </Box>
                </Grid> */}
            </Grid>

            <Grid container spacing={1.5} sx={{ mt: 1.5 }} className='align-items-stretch'>
                <Grid size={{ xs: 12, lg: 6 }} sx={{ minHeight: '500px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Box className="d-flex align-items-center justify-content-between">
                        <Typography className='fs-20 fw-bold text-white'>Sales Overview</Typography>
                        <select
                            className="bg-transparent text-white border-main  ps-2 py-2 border-10 fs-12"
                            style={{
                                outline: "none",
                                border: "1px solid #2a2a2a",
                                background: "var(--primary-bg-color)",
                            }}
                        >
                            <option>All Categories</option>
                            <option>Men</option>
                            <option>Women</option>
                            <option>Kids</option>
                        </select>
                    </Box>
                    <Box className='mt-2' sx={{ width: '100%', height: 400 }}>
                        <LineChart
                            className='text-white'
                            series={[
                                { data: pData, label: 'This Week', color: 'var(--secondary-color)' },
                                { data: uData, label: 'Last Week', color: 'var(--third-color)' },
                            ]}
                            xAxis={[{ scaleType: 'point', data: xLabels, height: 28, }]}
                            yAxis={[{ width: 50 }]}
                            margin={margin}
                            sx={{
                                "& .MuiChartsAxisHighlight-root": {
                                    stroke: "#fff !important",
                                },

                                // X & Y axis labels/ticks color
                                [`& .${axisClasses.tickLabel}`]: {
                                    fill: "#ffffff !important",
                                },

                                // Axis line color
                                [`& .${axisClasses.line}`]: {
                                    stroke: "#666",
                                },

                                // Tick color
                                [`& .${axisClasses.tick}`]: {
                                    stroke: "white",
                                },

                                // Legend text color
                                "& .MuiChartsLegend-label": {
                                    fill: "#ffffff !important",
                                    color: "#ffffff !important",
                                },

                                // Point color
                                "& .MuiMarkElement-root": {
                                    fill: "#ffffff",
                                    stroke: "#ffffff",
                                    r: 3,
                                },

                                "& .MuiChartsTooltip-paper": {
                                    backgroundColor: "var(--primary-bg-color) !important",
                                    color: "#fff !important",
                                    border: "1px solid #444",
                                    padding: '5px',
                                    borderRadius: "5px",
                                },

                                "& .MuiChartsTooltip-root *": {
                                    color: "#fff !important",
                                },


                            }}
                        />
                    </Box>
                    {/* <Box className='h-100 w-100 d-flex align-items-center justify-content-center'>
                                <Typography className='text-grey fs-32 m-auto text-center'> No Data Found</Typography>
                            </Box> */}

                </Grid>
                <Grid size={{ xs: 12, lg: 6 }} sx={{ minHeight: '500px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Box className="d-flex align-items-center justify-content-between">
                        <Typography className='fs-20 fw-bold text-white'>Recent Orders</Typography>
                        <Link to={'#'} className='fs-12 fw-bold text-yellow'>View All</Link>
                    </Box>
                    <Box className='w-100'>
                        {dashboardDetails?.recentOrders?.map((item:RecentOrder) => (
                            <Box className='row w-100 m-0  border-light-bottom p-0 py-3'>
                                <Box className='col overflow-hidden'>
                                    <Typography className='text-white fs-14 fw-bold'>{item?.orderNumber}</Typography>
                                    <Typography className='text-grey fs-14'>Ravi Patel</Typography>
                                </Box>
                                <Box className='col'>
                                    <Typography className='text-grey text-center fs-14'>{item?.quantity} Products</Typography>
                                </Box>
                                <Box className='col'>
                                    <Typography className='text-grey text-center fs-14'>${item?.amount}</Typography>
                                </Box>
                                <Box className='col'>
                                    <Typography className='text-grey text-center fs-14'>{dayjs(item?.orderedAt).format("MMM DD, YYYY")}</Typography>
                                </Box>
                                <Box className='col'>
                                    <Typography className='text-grey fs-14 text-center text-yellow bg-light-yellow border-5 px-2 py-1'>{item?.orderStatus}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    {/* <Box className='h-100 w-100 d-flex align-items-center justify-content-center'>
                                <Typography className='text-grey fs-32 m-auto text-center'> No Data Found</Typography>
                            </Box> */}

                </Grid>
            </Grid>
            <Grid container spacing={1.5} sx={{ mt: 1.5 }} className='align-items-stretch'>
                {/* <Grid size={{ xs: 12, lg: 9 }}  > */}
                {/* <Grid container spacing={1.5}> */}
                <Grid size={{ xs: 12, lg: 9 }} sx={{ minHeight: '570px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                    <Grid container spacing={2} className='h-100'>
                        {/* Top Products */}
                        <Grid size={12} className='h-100 w-100 d-flex flex-column'>
                            {/* Header */}
                            <Box className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                                <Typography className="fs-20 fw-bold text-white">
                                    Top Products
                                </Typography>

                                <Box className="d-flex align-items-center gap-2">
                                    <select
                                        className="bg-transparent text-white border-main  ps-2 py-2 border-10 fs-12"
                                        style={{
                                            outline: "none",
                                            border: "1px solid #2a2a2a",
                                            background: "var(--primary-bg-color)",
                                        }}
                                    >
                                        <option>All Categories</option>
                                        <option>Men</option>
                                        <option>Women</option>
                                        <option>Kids</option>
                                    </select>

                                    <Button
                                        className='text-yellow bg-light-yellow border-10 transform'
                                        variant="contained">
                                        + Add Product
                                    </Button>
                                </Box>
                            </Box>

                            {/* Table Header */}
                            <Box
                                className="row m-0 py-2 border-light-bottom"
                                sx={{
                                    color: "#8c8c8c",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                }}
                            >
                                <Box className="col-4">Product</Box>
                                <Box className="col text-center">Price</Box>
                                <Box className="col text-center">Sold</Box>
                                <Box className="col text-center">Revenue</Box>
                                <Box className="col text-center">Status</Box>
                                <Box className="col text-center">Action</Box>
                            </Box>

                            {/* Product Rows */}
                            {dashboardDetails?.topSellingProducts?.map((item:TopSellingProduct, index:number) => (
                                <Box
                                    key={index}
                                    className="row m-0 align-items-center py-3 border-light-bottom"
                                >
                                    <Box className="col-4 d-flex align-items-center gap-2">
                                        <Box
                                            component={"img"}
                                            src={item.images[0]}
                                            sx={{
                                                width: 42,
                                                height: 42,
                                                borderRadius: "12px",
                                                objectFit: "cover",
                                                border: "1px solid #2d2d2d",
                                            }}
                                        />

                                        <Box>
                                            <Typography className="text-white fs-14 fw-bold">
                                                {item.productName}
                                            </Typography>

                                            <Typography className="text-grey fs-12">
                                                {item.variantName}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box className="col text-center">
                                        <Typography className="text-white fs-12">
                                            ${item.price}
                                        </Typography>
                                    </Box>
                                    <Box className="col text-center">
                                        <Typography className="text-white fs-12">
                                            {item.totalSold}
                                        </Typography>
                                    </Box>

                                    <Box className="col text-center">
                                        <Typography className="text-white fs-12">
                                            ${item.revenue}
                                        </Typography>
                                    </Box>

                                    <Box className="col text-center">
                                        <Typography
                                            className="fs-11 fw-bold"
                                            sx={{
                                                background: "var(--third-light-color)",
                                                color: "var(--third-color)",
                                                px: 1.5,
                                                py: 0.7,
                                                borderRadius: "6px",
                                                display: "inline-block",
                                            }}
                                        >
                                            Active
                                        </Typography>
                                    </Box>

                                    <Box className="col text-center">
                                        <Box className="d-flex align-items-center justify-content-center gap-2">
                                            <IconButton className='p-2 border-main border-10'>
                                                <VisibilityOutlined className='fs-20 text-white' />
                                            </IconButton>

                                            <IconButton
                                                className='p-2 border-main border-10'
                                            >
                                                <EditOutlined className='fs-20 text-white' />
                                            </IconButton>

                                            <IconButton
                                                className='p-2 border-main border-10'
                                            >
                                                <MoreVert className='fs-20 text-white' />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}

                            {/* <Box sx={{ flex: 1 }} className='w-100 d-flex align-items-center justify-content-center'>
                                        <Typography className='text-grey fs-32 m-auto text-center'> No Data Found</Typography>
                                    </Box> */}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, lg: 3 }}>
                    <Grid container spacing={2} className='h-100'>
                        {/* <Grid size={12} sx={{ minHeight: '300px' }} className='bg-main border-10 border-main p-2 p-md-3'>
                            <Box className="d-flex align-items-center justify-content-between">
                                <Typography className='fs-20 fw-bold text-white'>Store Profile</Typography>
                                <Link to={'#'} className='fs-12 fw-bold text-yellow'>Edit</Link>
                            </Box>
                            <Box className='mt-2 d-flex flex-column align-items-center'>
                                <Box component={'img'} src={venderDetails?.logo_url} height={'150px'} width={'150px'} />
                                <Typography className='fs-20 fw-bold text-white'>{venderDetails?.display_name}</Typography>
                                <Typography className='fs-12 fw-bold text-grey'>Sports Team / Football Club <Verified className='text-yellow' /></Typography>
                                <Typography className='fs-12 fw-bold text-grey'><Star className='text-yellow' /> 4.8(230 Reviews)</Typography>
                                <Button className='text-yellow mt-2 bg-light-yellow px-4 transform py-1 border-5'>View Store</Button>
                            </Box>
                        </Grid> */}
                        <Grid size={12} sx={{ minHeight: '400px' }} className='bg-main d-flex flex-column border-10 border-main p-2 p-md-3'>
                            <Box className="d-flex align-items-center justify-content-between">
                                <Typography className='fs-20 fw-bold text-white'>Low Stock Alert</Typography>
                                <Link to={'#'} className='fs-12 fw-bold text-yellow'>View All</Link>
                            </Box>
                            <Box className='w-100'>
                                {[1, 2, 3, 4, 5].map((item) => (
                                    <Box className='row w-100 m-0 align-items-center   border-light-bottom p-0 py-3'>
                                        <Box className='col-auto border-50 m-1 p-0' component={'img'} height={'32px'} width={'32px'} />
                                        <Box className='col overflow-hidden'>
                                            <Typography className='text-white fs-14 fw-bold'>#WWWWWW1256</Typography>
                                            <Typography className='text-grey fs-12'>Ravi Patel</Typography>
                                        </Box>
                                        <Box className='col'>
                                            <Typography className='fs-12 text-end text-danger fw-bold border-5 px-2 py-1'>Stock: 4</Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                            {/* <Box sx={{ flex: 1 }} className='w-100 d-flex align-items-center justify-content-center'>
                                <Typography className='text-grey fs-28 m-auto text-center'> No Data Found</Typography>
                            </Box> */}

                        </Grid>
                        <Grid size={12} sx={{ minHeight: '200px' }} className='bg-main d-flex flex-column border-10 border-main p-2 p-md-3'>
                            <Box className="d-flex align-items-center justify-content-between">
                                <Typography className='fs-20 fw-bold text-white'>Latest Reviews</Typography>
                                <Link to={'#'} className='fs-12 fw-bold text-yellow'>View All</Link>
                            </Box>
                            <Box className='w-100'>
                                {[1, 2].map((item) => (
                                    <Box className='border-light-bottom p-0 py-3'>
                                        <Box className='row w-100 m-0 align-items-center p-0'>
                                            <Box className='col-auto border-50 m-1 p-0' component={'img'} height={'28px'} width={'28px'} />
                                            <Box className='col overflow-hidden'>
                                                <Typography className='text-white fs-14 fw-bold'>Ravi Patel</Typography>
                                                <Typography className='text-grey fs-12'><Star className='fs-12 text-yellow' /> <Star className='fs-12 text-yellow' /> <Star className='fs-12 text-yellow' /> <Star className='fs-12 text-yellow' /></Typography>
                                            </Box>
                                            <Box className='col'>
                                                <Typography className='fs-12 text-end text-grey'>Apr 23,2024</Typography>
                                            </Box>
                                        </Box>
                                        <Box className='mt-2'>
                                            <Typography className='fs-12 text-white'>Great quality jearsy! The favric is amazing</Typography>
                                            <Typography className='fs-10 text-grey'>Home Jersy 2024/25 - Black / M</Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>

                            {/* <Box sx={{ flex: 1 }} className='w-100 d-flex align-items-center justify-content-center'>
                                <Typography className='text-grey fs-28 m-auto text-center'> No Data Found</Typography>
                            </Box> */}

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/* </Grid> */}

        {/* </Grid> */}
        </Box >
    )
}

export default VenderDashboard
